import { render, staticRenderFns } from "./zhandian.vue?vue&type=template&id=0636ea56"
import script from "./zhandian.vue?vue&type=script&lang=js"
export * from "./zhandian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports